export var restRequest = function restRequest(type) {
  return {
    REQUEST: "".concat(type, ".REQUEST"),
    SUCCESS: "".concat(type, ".SUCCESS"),
    FAIL: "".concat(type, ".FAIL")
  };
};